import { createSelector } from 'reselect';
import ComparativeBagUsageColumns
  from '../../containers/ComparativeBagUsageColumns';
import ReportsDefinition from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.COMPARATIVE_BAG_USAGE_951.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.COMPARATIVE_BAG_USAGE_951.isLoading;

export const getData =
  ReportsDefinition.COMPARATIVE_BAG_USAGE_951.getDataFunction();

export const getColumns =
  createSelector(getData, ComparativeBagUsageColumns);

